<div class="dialog__port-summary-item">
  <div class="dialog__port-summary-left">
    <div class="dialog__port-number">{{ index() + 1 }}</div>
    <div class="dialog__port-text">{{ customerDescription() }}</div>
  </div>
  <div class="dialog__port-summary-right">
    <div>{{ initialPriority() }}</div>
    @if (hasChanged()) {
      <div class="dialog__port-summary-right-flex">
        <svg-icon src="assets/images/icons/arrow-long.svg"></svg-icon>
        <span class="blue">{{ bgpSessionPriority() }}</span>
      </div>
    }
  </div>
</div>
